import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
export function Dashboard() {
  return <div className="space-y-6" data-id="element-146">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-147">Order Info</h1>

      <p className="text-slate-600" data-id="element-148">
        Below is information about the new orders placed by your customers this
        month/this week/today or since your last log in to the administrator
        area.
      </p>

      <Card data-id="element-149">
        <CardContent className="p-0" data-id="element-150">
          <div className="overflow-x-auto" data-id="element-151">
            <table className="w-full text-sm text-left" data-id="element-152">
              <thead className="bg-slate-800 text-white" data-id="element-153">
                <tr data-id="element-154">
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-155">
                    Status
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-156">
                    Since Last Login
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-157">
                    Today
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-158">
                    This Week
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700" data-id="element-159">
                    This Month
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-160">
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-161">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-162">
                    Processed
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-163">
                    34
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-164">
                    20
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-165">
                    66
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-166">189</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-167">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-168">
                    Failed/Declined
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-169">
                    2
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-170">
                    1
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-171">
                    3
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-172">10</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-173">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-174">
                    Not Finished
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-175">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-176">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-177">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-178">0</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-179">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-180">
                    Total Paid
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-181">
                    $1325.24
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-182">
                    $724.58
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-183">
                    $3078.7
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-184">$9063.84</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>

      <div data-id="element-185">
        <Link to="/orders" className="text-blue-600 hover:text-blue-800 hover:underline text-sm font-medium" data-id="element-186">
          Order Search
        </Link>
      </div>
    </div>;
}